import {COMPANY_SETTINGS} from 'app/app.constants';
import {Store} from '@ngxs/store';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SettingsService {
    constructor(private _store: Store) {}

    /*
     * 1. we will be using, subscribeToSetting() and subscribeToSettingOption() from now on as they are asynchronous methods which subscribe to the value we require
     * and updates the same on the frontend wherever we are using these settings.
     *
     * 2. the callbackToSubscription argument will work only when the value has been subscribed and available as some defined value (string/boolean/etc)
     * and needs to be sent as an argument to set the setting values.
     *
     * */

    public subscribeToSetting(key: string, callbackToSubscription: (value: any) => void): void {
        this._store
            .select<string>((state) => state.common[COMPANY_SETTINGS][key])
            .pipe()
            .subscribe((value) => {
                if (value) {
                    try {
                        const parsedValue = JSON.parse(value);
                        callbackToSubscription(parsedValue);
                    } catch (e) {
                        console.error('Error parsing JSON:', e);
                        return;
                    }
                }
            });
    }

    public subscribeToSettingWithoutParsing(key: string, callbackToSubscription: (value: any) => void): void {
        this._store
            .select<string>((state) => state.common[COMPANY_SETTINGS][key])
            .pipe()
            .subscribe((value) => {
                if (value) {
                    callbackToSubscription(value);
                }
            });
    }

    public subscribeToSettingOption(key: string, callbackToSubscription: (value: any) => void): void {
        this._store
            .select<string>((state) => state.common[COMPANY_SETTINGS][key])
            .pipe()
            .subscribe((value) => {
                if (value) {
                    callbackToSubscription(value);
                }
            });
    }

    /*
     * getSetting() and getSettingOption() is deprecated as it uses select snapshot which is a synchronous call, but we need an asynchronous method to set the setting values
     * once the state has been initialised/persisted in the Store. If we use select snapshot it will throw an error for null exceptions as we are trying to get the setting value
     * before the state has been initialised/persisted in the Store. Even though the methods defined below are archived for view/create-edit/list/modals components they are still
     * used in xyz.service.ts files, so please don't delete or comment the below
     */

    public getSetting(key: any): any {
        const snapshot = this._store.selectSnapshot<string>((state) => state.common[COMPANY_SETTINGS][key]);
        if (snapshot == null) {
            return null;
        }

        return JSON.parse(snapshot);
    }

    public getSettingOption(key: any): any {
        const settingValue = this._store.selectSnapshot<string>((state) => state.common[COMPANY_SETTINGS][key]);
        return settingValue;
    }
}
